import { debounce } from 'lodash';
import { useMemo, useEffect, useState } from 'react';
import { Box, Flex, Text, Textarea } from '@chakra-ui/react';

const TextAreaComp = ({
    label = 'Label',
    placeholder = 'Placeholder...',
    value = '',
    onChange = () => {},
    resize = 'none',
    helperText = '',
    isInvalid = false,
    debounceDelay = 500,
    isSideLabel = false,
}) => {
    const [localValue, setLocalValue] = useState(value);

    const Container = !isSideLabel ? Box : Flex;

    useEffect(() => {
        setLocalValue(value);
    }, [value]);

    const debouncedOnChange = useMemo(
        () =>
            debounce((val) => {
                onChange(val);
            }, debounceDelay),
        [onChange, debounceDelay]
    );

    useEffect(() => {
        return () => {
            debouncedOnChange.cancel();
        };
    }, [debouncedOnChange]);

    const handleChange = (e) => {
        const val = e.target.value;
        setLocalValue(val);
        debouncedOnChange(val);
    };
    return (
        <Container>
            <Text fontSize={'14px'} fontWeight={'700'} mb={'8px'} flex={0.2}>
                {label}
            </Text>
            <Box flex={0.75} ml={'auto'}>
                <Textarea
                    value={localValue}
                    onChange={handleChange}
                    placeholder={placeholder}
                    resize={resize}
                    fontSize={'14px'}
                    isInvalid={isInvalid}
                    _invalid={{
                        borderColor: 'danger.500',
                    }}
                />
                {helperText && (
                    <Text fontSize={'10px'} mt={'8px'} color={isInvalid ? 'danger.500' : 'semantic.500'}>
                        {helperText}
                    </Text>
                )}
            </Box>
        </Container>
    );
};

export default TextAreaComp;
